import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';

export interface CompetenciaDTO {
  VALOR: string;
  DESCRICAO: string;
}
export interface TipoFolhaDTO {
  VALOR: string;
  DESCICAO: string;
}
export interface LotacaoDTO {
  VALOR: string;
  DESCRICAO: string;
}
export interface VinculoDTO {
  VALOR: number | string;
  DESCRICAO: string;
}

export interface GerarRelatorioPayload {
  sigla: string;
  empfil: string;
  competencia: string;
  tipoFolha: string;
  lotacao: string | null;
  vinculosSelecionados: Array<number | string>;
  emissor?: string;
}

export interface RelatorioResposta {
  Base64: string;
  NomeArquivo?: string;
}

@Injectable({ providedIn: 'root' })
export class FolhaPagamentoService {
  private readonly relatoriosBase = 'https://api-relatorios-php.elogica.info';

  private readonly basicUser = '3l0g1k4';
  private readonly basicPass = 'dtr5x8!qAa6>';

  localStorage: LocalStorage = new LocalStorage();

  constructor(private http: HttpClient) {
    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
  }

  private basicHeadersGET(): HttpHeaders {
    const token = btoa(`${this.basicUser}:${this.basicPass}`);
    return new HttpHeaders({
      Authorization: `Basic ${token}`,
      Accept: 'application/json',
    });
  }

  private basicHeadersJSON(): HttpHeaders {
    const token = btoa(`${this.basicUser}:${this.basicPass}`);
    return new HttpHeaders({
      Authorization: `Basic ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
  }

  private baseUrl(path: string): string {
    return `${this.relatoriosBase}${path}`;
  }

  listarCompetencias(sigla: string, empfil: string) {
    const url = this.baseUrl(
      `/competencias-folha/${encodeURIComponent(sigla)}/${encodeURIComponent(empfil)}`
    );
    return this.http.get<CompetenciaDTO[]>(url, { headers: this.basicHeadersGET() });
  }

  listarTiposFolha(sigla: string, dtcomp: string, empfil: string) {
    const url = this.baseUrl(
      `/tipos-folha/${encodeURIComponent(sigla)}/${encodeURIComponent(dtcomp)}/${encodeURIComponent(
        empfil
      )}`
    );
    return this.http.get<TipoFolhaDTO[]>(url, { headers: this.basicHeadersGET() });
  }

  listarLotacoes(sigla: string, dtcomp: string, empfil: string, tipofolha: string) {
    const url = this.baseUrl(
      `/lotacoes-folha/${encodeURIComponent(sigla)}/${encodeURIComponent(
        dtcomp
      )}/${encodeURIComponent(empfil)}/${encodeURIComponent(tipofolha)}`
    );
    return this.http.get<LotacaoDTO[]>(url, { headers: this.basicHeadersGET() });
  }

  listarVinculos(sigla: string, dtcomp: string, empfil: string, tipofolha: string) {
    const url = this.baseUrl(
      `/vinculos-folha/${encodeURIComponent(sigla)}/${encodeURIComponent(
        dtcomp
      )}/${encodeURIComponent(empfil)}/${encodeURIComponent(tipofolha)}`
    );
    return this.http.get<VinculoDTO[]>(url, { headers: this.basicHeadersGET() });
  }

  listarVinculosComLotacao(
    sigla: string,
    dtcomp: string,
    empfil: string,
    tipofolha: string,
    lotacao: string
  ) {
    const url = this.baseUrl(
      `/vinculos-folha/${encodeURIComponent(sigla)}/${encodeURIComponent(
        dtcomp
      )}/${encodeURIComponent(empfil)}/${encodeURIComponent(tipofolha)}/${encodeURIComponent(
        lotacao
      )}`
    );
    return this.http.get<VinculoDTO[]>(url, { headers: this.basicHeadersGET() });
  }

  gerarRelatorio(payload: GerarRelatorioPayload) {
    const { sigla, empfil, competencia: dtcomp, tipoFolha: tpproc } = payload;

    const vinculo = payload.vinculosSelecionados?.length
      ? payload.vinculosSelecionados.join(', ')
      : undefined;

    const lotacaoNum = payload.lotacao ? Number(payload.lotacao) : undefined;
    const emissor = payload.emissor ?? this.localStorage?.NomeUsuario ?? 'Relatórios';

    const body: { emissor: string; vinculo?: string; lotacao?: number } = { emissor };
    if (vinculo) body.vinculo = vinculo;
    if (typeof lotacaoNum === 'number' && !Number.isNaN(lotacaoNum)) body.lotacao = lotacaoNum;

    const url = this.baseUrl(
      `/folha-pagamento/${encodeURIComponent(sigla)}/${encodeURIComponent(
        dtcomp
      )}/${encodeURIComponent(empfil)}/${encodeURIComponent(tpproc)}`
    );
    return this.http.post<RelatorioResposta>(url, body, { headers: this.basicHeadersJSON() });
  }

  gerarRelatorioBlob(payload: GerarRelatorioPayload) {
    const { sigla, empfil, competencia: dtcomp, tipoFolha: tpproc } = payload;

    const vinculo = payload.vinculosSelecionados?.length
      ? payload.vinculosSelecionados.join(', ')
      : undefined;

    const lotacaoNum = payload.lotacao ? Number(payload.lotacao) : undefined;
    const emissor = payload.emissor ?? this.localStorage?.NomeUsuario ?? 'Relatórios';

    const body: { emissor: string; vinculo?: string; lotacao?: number } = { emissor };
    if (vinculo) body.vinculo = vinculo;
    if (typeof lotacaoNum === 'number' && !Number.isNaN(lotacaoNum)) body.lotacao = lotacaoNum;

    const url = this.baseUrl(
      `/folha-pagamento/${encodeURIComponent(sigla)}/${encodeURIComponent(
        dtcomp
      )}/${encodeURIComponent(empfil)}/${encodeURIComponent(tpproc)}`
    );
    return this.http.post(url, body, { headers: this.basicHeadersJSON(), responseType: 'blob' });
  }
}
